import { render } from "./AppTexto.vue?vue&type=template&id=8ac399a8&scoped=true"
import script from "./AppTexto.vue?vue&type=script&lang=js"
export * from "./AppTexto.vue?vue&type=script&lang=js"

import "./AppTexto.vue?vue&type=style&index=0&id=8ac399a8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ac399a8"]])

export default __exports__